import React, { useState, useEffect } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
  ButtonGroup,
  LinearProgress,
  Chip,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialButton from "../../../../components/MaterialButton";
import ConfirmationDialog from "../../../../components/Dialog/ConfirmationDialog";
import axios from "axios";
import BASEURL from "../../../Utils/Baseurl";
import { useNavigate } from "react-router-dom";
import MaterialSnackbar from "../../../../components/MaterialSnackbar";
import NotificationsIcon from "@mui/icons-material/Notifications";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Swal from "sweetalert2";
import { useUserDetails } from "../../../../context/auth";
import { useLoading } from "../../../../context/loading";
import loading from "../../../../assest/images/loading.svg";
import error from "../../../../assest/images/404.svg";

const AddShift = () => {
  const navigate = useNavigate();
  const { circleLoading, setCirleLoading } = useLoading();
  const [id, setId] = useState(null);
  const { AccessData } = useUserDetails();
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });
  const [snackBar, setSnackBar] = useState({
    Success: false,
    Error: false,
  });
  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });

  const [shifData, setShiftData] = useState({
    name: "",
    duration: "",
    startTime: "",
    endTime: "",
    gracePeriodMinutes: 15,
    nameStatus: "unchecked",
    durationStatus: "unchecked",
    startTimeStatus: "unchecked",
    endTimeStatus: "unchecked",
    gracePeriodStatus: "success",
    // Display-only fields
    shiftType: "",
    isOvernight: false,
  });

  const [originalshiftData, setoriginalshiftData] = useState({
    name: "",
    startTime: "",
    endTime: "",
    duration: "",
    gracePeriodMinutes: 15,
  });

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    setId(id);
    if (id) {
      getInitData(id);
    } else {
      setPageState((prevState) => ({
        ...prevState,
        loading: false,
        state: "default",
      }));
    }
  }, []);

  // Calculate duration from start and end time
  const calculateDuration = (start, end) => {
    if (!start || !end) return "";
    const [sh, sm] = start.split(":").map(Number);
    const [eh, em] = end.split(":").map(Number);
    let startMin = sh * 60 + sm;
    let endMin = eh * 60 + em;
    if (endMin <= startMin) {
      endMin += 24 * 60; // overnight shift
    }
    return ((endMin - startMin) / 60).toFixed(1);
  };

  // Detect shift type from start/end times
  const detectShiftType = (start, end) => {
    if (!start || !end) return { type: "General", overnight: false };
    const [sh] = start.split(":").map(Number);
    const [eh] = end.split(":").map(Number);
    const startMin = sh * 60;
    const endMin = eh * 60;
    const overnight = endMin < startMin || (endMin === startMin && end !== start);
    if (overnight) return { type: "Night", overnight: true };
    if (sh >= 6 && eh <= 22) return { type: "Day", overnight: false };
    return { type: "General", overnight: false };
  };

  const onshiftSubmit = async () => {
    setCirleLoading(true);
    const query = `
          mutation CreateShift($shiftData: ShiftInput!) {
            createShift(shiftData: $shiftData) {
              shift {
                id
                name
                startTime
                endTime
                totalWorkingHours
                shiftType
                isOvernight
                gracePeriodMinutes
              }
            }
          }
        `;

    try {
      const shiftInput = {
        name: shifData.name,
        gracePeriodMinutes: parseInt(shifData.gracePeriodMinutes) >= 0 ? parseInt(shifData.gracePeriodMinutes) : 15,
        startTime: shifData.startTime,
        endTime: shifData.endTime,
        // totalWorkingHours is auto-calculated by backend from start/end times
      };

      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: JSON.stringify({
          query,
          variables: { shiftData: shiftInput },
        }),
      });

      const result = response.data.data?.createShift?.shift;
      if (result) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Shift Submitted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/shift");
      } else if (response.data.errors) {
        Swal.fire({
          position: "center",
          icon: "error",
          title: response.data.errors[0]?.message || "Error creating shift",
          showConfirmButton: false,
          timer: 2500,
        });
      }
      setConfirmationDialog({ ...confirmationDialog, open: false });
    } catch (err) {
      console.error("responseError:", err.response?.data || err);
      setConfirmationDialog({
        open: true,
        title: "Error Message",
        message: err?.message || "Something went wrong!",
        showCancel: true,
        showConfirm: false,
        onCancel: () => setConfirmationDialog({ ...confirmationDialog, open: false }),
      });
    } finally {
      setCirleLoading(false);
    }
  };

  const oneditshiftSubmit = async () => {
    const query = `
            mutation editShift($id: ID!, $shiftData: ShiftInput!) {
  editShift(id: $id, shiftData: $shiftData) {
    shift {
      id
      name
      startTime
      endTime
      totalWorkingHours
      shiftType
      isOvernight
      gracePeriodMinutes
    }
  }
}
        `;

    try {
      const shiftInput = {
        name: shifData.name,
        gracePeriodMinutes: parseInt(shifData.gracePeriodMinutes) >= 0 ? parseInt(shifData.gracePeriodMinutes) : 15,
        startTime: shifData.startTime,
        endTime: shifData.endTime,
        // totalWorkingHours is auto-calculated by backend from start/end times
      };

      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: JSON.stringify({
          query,
          variables: { id: id, shiftData: shiftInput },
        }),
      });

      if (response.data.data.editShift == null) {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "This shift is mapped to an employee and cannot be edited",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/shift");
      } else {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Shift Updated Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/shift");
      }
      setConfirmationDialog({ ...confirmationDialog, open: false });
    } catch (err) {
      console.error("responseError:", err);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message: "Sorry for the inconvenience, there is an issue with our network. Please try again later.",
        showCancel: true,
        showConfirm: false,
        onCancel: () => setConfirmationDialog({ ...confirmationDialog, open: false }),
      });
    }
  };

  const AddDelete = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        ondeleteSubmitShift();
        setConfirmationDialog({ ...confirmationDialog, open: false });
      },
      onCancel: () => setConfirmationDialog({ ...confirmationDialog, open: false }),
    });
  };

  const ondeleteSubmitShift = async () => {
    const query = `
           mutation DeleteShift($id: ID!) {
  deleteShift(id: $id) {
                success
  }
}
        `;

    try {
      const response = await axios.post(BASEURL, {
        query: query,
        variables: { id: id },
      });

      const result = response.data.data.deleteShift;
      if (result.success) {
        navigate("/shift");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Shift Deleted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
      } else {
        console.error("Error deleting Shift:", result.message || "Unknown error");
      }
    } catch (err) {
      console.error("An error occurred while deleting the Shift:", err);
    } finally {
      setCirleLoading(false);
    }
  };

  const getInitData = async (id) => {
    setCirleLoading(true);
    setPageState({ ...pageState, loading: true, state: "init" });
    const query = `
  query getShiftById($id: ID!) {
  shiftById(id: $id) {
    id
    name
    startTime
    endTime
    totalWorkingHours
    shiftType
    isOvernight
    gracePeriodMinutes
  }
}
              `;
    try {
      setPageState({ ...pageState, loading: true });
      const response = await axios.post(
        BASEURL,
        { query: query, variables: { id } },
        { headers: { "Content-Type": "application/json" } }
      );

      const shiftRowData = response.data.data.shiftById;

      // Format time from "HH:MM:SS" to "HH:MM" for input fields
      const formatTimeForInput = (t) => {
        if (!t) return "";
        return t.substring(0, 5); // "09:00:00" -> "09:00"
      };

      const startT = formatTimeForInput(shiftRowData.startTime);
      const endT = formatTimeForInput(shiftRowData.endTime);

      setShiftData({
        name: shiftRowData.name,
        startTime: startT,
        endTime: endT,
        duration: (shiftRowData?.totalWorkingHours / 3600).toFixed(1),
        gracePeriodMinutes: shiftRowData.gracePeriodMinutes || 15,
        nameStatus: "success",
        durationStatus: "success",
        startTimeStatus: startT ? "success" : "unchecked",
        endTimeStatus: endT ? "success" : "unchecked",
        gracePeriodStatus: "success",
        shiftType: shiftRowData.shiftType || "",
        isOvernight: shiftRowData.isOvernight || false,
      });

      setoriginalshiftData({
        name: shiftRowData.name,
        startTime: startT,
        endTime: endT,
        duration: (shiftRowData?.totalWorkingHours / 3600).toFixed(1),
        gracePeriodMinutes: shiftRowData.gracePeriodMinutes || 15,
      });
      setTogglePage({ ...togglePage, view: true });
      setPageState((prevState) => ({
        ...prevState,
        loading: false,
        state: "default",
      }));
    } catch (err) {
      console.error("ResponseError:", err);
      setPageState({
        ...pageState,
        loading: false,
        message:
          "We are unable to fetch the required data at this time. Please try again later.",
        state: "error",
      });
    } finally {
      setCirleLoading(false);
    }
  };

  const handleShiftchange = (event) => {
    let shiftState = { ...shifData };

    switch (event.target.name) {
      case "name": {
        const alphaLengthRegex = new RegExp("^([a-zA-Z0-9 ]{1,25})$");
        shiftState[event.target.name + "Status"] = alphaLengthRegex.test(
          event.target.value?.trim()
        )
          ? "success"
          : event.target.value === ""
          ? "unchecked"
          : "error";
        break;
      }
      case "duration": {
        shiftState[event.target.name + "Status"] =
          event.target.value >= 1 && event.target.value <= 24
            ? "success"
            : "error";
        break;
      }
      case "startTime": {
        if (event.target.value?.trim()) {
          shiftState[event.target.name + "Status"] = "success";
          // Auto-calculate duration if end time exists
          if (shiftState.endTime) {
            const dur = calculateDuration(event.target.value, shiftState.endTime);
            shiftState.duration = dur;
            shiftState.durationStatus = dur > 0 ? "success" : "error";
            const { type, overnight } = detectShiftType(event.target.value, shiftState.endTime);
            shiftState.shiftType = type.toUpperCase();
            shiftState.isOvernight = overnight;
          }
        } else {
          shiftState[event.target.name + "Status"] = "unchecked";
        }
        break;
      }
      case "endTime": {
        if (event.target.value?.trim()) {
          shiftState[event.target.name + "Status"] = "success";
          // Auto-calculate duration if start time exists
          if (shiftState.startTime) {
            const dur = calculateDuration(shiftState.startTime, event.target.value);
            shiftState.duration = dur;
            shiftState.durationStatus = dur > 0 ? "success" : "error";
            const { type, overnight } = detectShiftType(shiftState.startTime, event.target.value);
            shiftState.shiftType = type.toUpperCase();
            shiftState.isOvernight = overnight;
          }
        } else {
          shiftState[event.target.name + "Status"] = "unchecked";
        }
        break;
      }
      case "gracePeriodMinutes": {
        const val = parseInt(event.target.value);
        shiftState.gracePeriodStatus =
          val >= 0 && val <= 120 ? "success" : "error";
        break;
      }
      default:
        break;
    }

    shiftState[event.target.name] = event.target.value;
    setShiftData(shiftState);
  };

  const onAddShift = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => onshiftSubmit(),
      onCancel: () => setConfirmationDialog({ ...confirmationDialog, open: false }),
    });
  };

  const toggleEdit = () => {
    setTogglePage({ view: false, edit: true });
  };

  const ondiscardShift = () => {
    setTogglePage({ view: true, edit: false });
    setShiftData({
      ...shifData,
      name: originalshiftData.name,
      startTime: originalshiftData.startTime,
      endTime: originalshiftData.endTime,
      duration: originalshiftData.duration,
      gracePeriodMinutes: originalshiftData.gracePeriodMinutes,
    });
  };

  const checkAllFields = () => {
    if (shifData?.nameStatus !== "success") return false;
    // Start time and end time are required (duration is auto-calculated)
    if (shifData?.startTimeStatus !== "success" || shifData?.endTimeStatus !== "success") return false;
    if (shifData?.durationStatus === "error") return false;
    if (shifData?.gracePeriodStatus === "error") return false;
    return true;
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      {pageState.state === "init" ? (
        <Card>
          <MaterialBox>
            <MaterialBox
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                height: "74vh",
                margin: "auto",
              }}
            >
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                spacing={2}
                padding={10}
              >
                <Grid size={{ xs: 6, sm: 6 }}>
                  <MaterialTypography variant="body2" mb={3}>
                    Please wait while we fetch the Shift details for you. This
                    may take a few seconds.
                  </MaterialTypography>
                  <MaterialBox
                    style={{ overflow: "hidden", borderRadius: 5, height: 24 }}
                  >
                    <LinearProgress
                      size="lg"
                      color="dark"
                      thickness={16}
                      style={{ borderRadius: 5, height: 16, maxHeight: 16 }}
                      sx={{ "& .MuiLinearProgress-bar": { height: 16 } }}
                    />
                  </MaterialBox>
                </Grid>
              </Grid>
            </MaterialBox>
          </MaterialBox>
        </Card>
      ) : (
        <Card>
          <CardHeader
            title={
              <>
                {togglePage.view === true || togglePage.edit === true ? (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="row" spacing={2} alignItems="center">
                      <MaterialTypography variant="h5" fontWeight="medium">
                        {togglePage.view === true
                          ? "View Shift Details"
                          : "Edit Shift Details"}
                      </MaterialTypography>
                      {shifData.shiftType && (
                        <Chip
                          label={shifData.shiftType}
                          color={
                            shifData.shiftType === "NIGHT"
                              ? "secondary"
                              : shifData.shiftType === "DAY"
                              ? "primary"
                              : "default"
                          }
                          size="small"
                        />
                      )}
                      {shifData.isOvernight && (
                        <Chip label="Overnight" color="warning" size="small" />
                      )}
                    </Stack>
                    {AccessData &&
                      Array.isArray(AccessData) &&
                      AccessData.some(
                        (item) =>
                          item.component === "EditShift" && item.can_access
                      ) &&
                      togglePage?.view && (
                        <ButtonGroup variant="outlined" aria-label="button group">
                          <MaterialButton
                            variant="gradient"
                            color="dark"
                            onClick={toggleEdit}
                            startIcon={<EditIcon />}
                          >
                            Edit
                          </MaterialButton>
                          <MaterialButton
                            variant="gradient"
                            color="dark"
                            onClick={AddDelete}
                            startIcon={<DeleteIcon />}
                          >
                            Delete
                          </MaterialButton>
                        </ButtonGroup>
                      )}
                  </Stack>
                ) : (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography variant="h5" fontWeight="medium">
                        Add Shift Details
                      </MaterialTypography>
                    </Stack>
                  </Stack>
                )}
              </>
            }
          />
          <CardContent
            sx={{
              minHeight: pageState.state === "submitting" ? "65vh" : "70vh",
            }}
          >
            {pageState.state === "error" && (
              <MaterialBox>
                <Grid container spacing={1} textAlign="center">
                  <Grid size={{ xs: 12, sm: 12 }}>
                    <img src={error} alt="error" style={{ width: "30%" }} />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 12 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography variant="h6" fontWeight="bold">
                        {pageState.message}
                      </MaterialTypography>
                    </MaterialBox>
                  </Grid>
                </Grid>
              </MaterialBox>
            )}

            {pageState.state === "default" && !pageState.loading && (
              <MaterialBox>
                <Grid container spacing={2}>
                  {/* Row 1: Name */}
                  <Grid size={{ xs: 6, sm: 6 }}>
                    <MaterialBox>
                      <MaterialBox lineHeight={0} display="inline-block">
                        <MaterialTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                        >
                          Shift Name <span style={{ color: "red" }}>*</span>
                        </MaterialTypography>
                      </MaterialBox>
                      <MaterialInput
                        name="name"
                        placeholder="eg. Day Shift, Night Shift"
                        value={shifData.name}
                        onChange={handleShiftchange}
                        error={shifData.nameStatus === "error"}
                        success={shifData.nameStatus === "success"}
                        disabled={togglePage.view === true}
                      />
                      {shifData.nameStatus === "error" && (
                        <FormControl error>
                          <FormHelperText>
                            Shift Name should be a maximum of 25 characters.
                          </FormHelperText>
                        </FormControl>
                      )}
                    </MaterialBox>
                  </Grid>

                  {/* Row 1: Grace Period */}
                  <Grid size={{ xs: 6, sm: 6 }}>
                    <MaterialBox>
                      <MaterialBox lineHeight={0} display="inline-block">
                        <MaterialTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                        >
                          Grace Period (minutes)
                        </MaterialTypography>
                      </MaterialBox>
                      <MaterialInput
                        name="gracePeriodMinutes"
                        type="number"
                        placeholder="eg. 15"
                        value={shifData.gracePeriodMinutes}
                        onChange={handleShiftchange}
                        error={shifData.gracePeriodStatus === "error"}
                        success={shifData.gracePeriodStatus === "success"}
                        disabled={togglePage.view === true}
                        inputProps={{ min: 0, max: 120 }}
                      />
                      {shifData.gracePeriodStatus === "error" && (
                        <FormControl error>
                          <FormHelperText>
                            Grace period must be between 0 and 120 minutes.
                          </FormHelperText>
                        </FormControl>
                      )}
                    </MaterialBox>
                  </Grid>

                  {/* Row 2: Start Time */}
                  <Grid size={{ xs: 6, sm: 6 }}>
                    <MaterialBox>
                      <MaterialBox lineHeight={0} display="inline-block">
                        <MaterialTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                        >
                          Start Time <span style={{ color: "red" }}>*</span>
                        </MaterialTypography>
                      </MaterialBox>
                      <MaterialInput
                        name="startTime"
                        type="time"
                        value={shifData.startTime}
                        onChange={handleShiftchange}
                        error={shifData.startTimeStatus === "error"}
                        success={shifData.startTimeStatus === "success"}
                        disabled={togglePage.view === true}
                      />
                    </MaterialBox>
                  </Grid>

                  {/* Row 2: End Time */}
                  <Grid size={{ xs: 6, sm: 6 }}>
                    <MaterialBox>
                      <MaterialBox lineHeight={0} display="inline-block">
                        <MaterialTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                        >
                          End Time <span style={{ color: "red" }}>*</span>
                        </MaterialTypography>
                      </MaterialBox>
                      <MaterialInput
                        name="endTime"
                        type="time"
                        value={shifData.endTime}
                        onChange={handleShiftchange}
                        error={shifData.endTimeStatus === "error"}
                        success={shifData.endTimeStatus === "success"}
                        disabled={togglePage.view === true}
                      />
                    </MaterialBox>
                  </Grid>

                  {/* Row 3: Duration (auto-calculated from start & end time) */}
                  <Grid size={{ xs: 6, sm: 6 }}>
                    <MaterialBox>
                      <MaterialBox lineHeight={0} display="inline-block">
                        <MaterialTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                        >
                          Shift Duration (hours){" "}
                          <span style={{ color: "#777", fontWeight: "normal" }}>(auto-calculated)</span>
                        </MaterialTypography>
                      </MaterialBox>
                      <MaterialInput
                        name="duration"
                        type="number"
                        placeholder="Set start & end time"
                        value={shifData.duration}
                        inputProps={{ min: 0, max: 24, step: 0.1 }}
                        error={shifData.durationStatus === "error"}
                        success={shifData.durationStatus === "success"}
                        disabled={true}
                      />
                      {shifData.durationStatus === "error" && (
                        <FormControl error>
                          <FormHelperText>
                            Duration must be between 1 and 24 hours.
                          </FormHelperText>
                        </FormControl>
                      )}
                    </MaterialBox>
                  </Grid>

                  {/* Row 3: Shift Type Display */}
                  <Grid size={{ xs: 6, sm: 6 }}>
                    {(shifData.shiftType || shifData.isOvernight) && (
                      <MaterialBox mt={3}>
                        <Stack direction="row" spacing={1} alignItems="center">
                          {shifData.shiftType && (
                            <Chip
                              label={`Type: ${shifData.shiftType}`}
                              color={
                                shifData.shiftType === "NIGHT"
                                  ? "secondary"
                                  : shifData.shiftType === "DAY"
                                  ? "primary"
                                  : "default"
                              }
                              size="small"
                            />
                          )}
                          {shifData.isOvernight && (
                            <Chip
                              label="Overnight Shift"
                              color="warning"
                              size="small"
                            />
                          )}
                        </Stack>
                      </MaterialBox>
                    )}
                  </Grid>
                </Grid>
              </MaterialBox>
            )}

            {pageState.state === "submitting" && !pageState.loading && (
              <MaterialBox>
                <MaterialBox
                  justifyContent="center"
                  alignItems="center"
                  display="flex"
                  flexDirection="column"
                  minHeight="50vh"
                >
                  <MaterialTypography
                    variant="h6"
                    fontWeight="bold"
                    textAlign="center"
                  >
                    Adding your Shift data. This should not take much time.
                  </MaterialTypography>
                  <MaterialBox mt={2}>
                    <img src={loading} alt="loading" width="200px" />
                  </MaterialBox>
                </MaterialBox>
              </MaterialBox>
            )}
          </CardContent>
          {pageState.state !== "submitting" && (
            <MaterialBox
              display="flex"
              justifyContent="flex-end"
              alignItems="center"
            >
              {togglePage.edit === true ? (
                <>
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    disabled={pageState.state === "submitting"}
                    onClick={ondiscardShift}
                  >
                    Discard
                  </MaterialButton>

                  <MaterialButton
                    sx={{ m: 2 }}
                    variant="gradient"
                    color="dark"
                    disabled={!checkAllFields()}
                    onClick={oneditshiftSubmit}
                  >
                    Update
                  </MaterialButton>
                </>
              ) : togglePage.view === false && togglePage.edit === false ? (
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  disabled={!checkAllFields() || pageState.state === "submitting"}
                  onClick={onAddShift}
                >
                  Submit
                </MaterialButton>
              ) : null}
            </MaterialBox>
          )}
          <MaterialSnackbar
            color="success"
            icon={<NotificationsIcon />}
            title="Message"
            content="You have been submitted successfully"
            open={snackBar.Success}
            close={() => setSnackBar({ Success: false })}
          />
          <MaterialSnackbar
            color="error"
            position="Top"
            icon={<NotificationsIcon />}
            title="Message"
            content="Please check the shift timings."
            open={snackBar.Error}
            close={() => setSnackBar({ Error: false })}
          />
        </Card>
      )}
    </DashboardLayout>
  );
};

export default AddShift;
